import { PartiposterProfile } from 'state/submissions'

export function separatePartiposterProfile<T extends { partiposter_profile: PartiposterProfile }>(
    data: T[],
): {
    profileById: Record<string, PartiposterProfile>
    data: (Omit<T, 'partiposter_profile'> & { partiposterId: string })[]
} {
    const profileById: Record<string, PartiposterProfile> = {}
    return {
        profileById,
        data: data.map(initData => {
            const { partiposter_profile, ...data } = initData
            const { uuid: partiposterId } = partiposter_profile
            const computedData = { ...data, partiposterId }
            profileById[partiposterId] = partiposter_profile
            return computedData
        }),
    }
}
